/* 
  计算时间间隔内的有效天
  day1, day2 目前用的 2020-01-02 格式，也可以自定义时间戳
*/

const getValidDateNum = {
  methods: {
    rangeDay(day1, day2) {
      if (!day1 || !day2) return 0
      const res = []
      const dayTime = 24 * 60 * 60 * 1000
      const startTime = new Date(day1).getTime()
      const range = new Date(day2).getTime() - startTime
      let total = 0
      while (total <= range) {
        res.push(new Date(startTime + total).toLocaleDateString().replace(/\//g, '-'))
        total += dayTime
      }
      return res
    },
  },
}

export default getValidDateNum
